import React from 'react';
import { AppComponent } from 'utils/components';

export default function Table(props: { component: AppComponent }) {
	console.warn('unimplemented', props.component);

	return <div>table</div>;
}
